import React, { FunctionComponent } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAuth } from '../context/auth';

interface Props {
  route: object;
}

const MakeSubRoutes: FunctionComponent<any> = (route) => {
  const isAuthenticated = useAuth();
  if (!isAuthenticated && route.isPrivate) {
    console.log('Redirecting to Login Page');
    window.location.href = '/operatorlogin';
  }

  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => {
        return isAuthenticated || !route.isPrivate ? (
          route.redirect ? (
            <Redirect to={route.redirect} />
          ) : (
            <route.component {...props} routes={route.routes} locale={route.locale} />
          )
        ) : (
          <Redirect to="/operatorlogin" />
        );
      }}
    />
  );
};

export default MakeSubRoutes;
